var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-plot",staticStyle:{"height":"800px","text-align":"center"}},[_c('div',{staticStyle:{"display":"inline-flex","background":"#f5f7fa","border-radius":"14px","margin-bottom":"20px"}},[_c('div',{class:[
      'calMethod',
      _vm.adj_or_not == 'adj'
        ? `calMethod-active-${_vm.calMethod}`
        : 'calMethod-deactive',
    ],on:{"click":function($event){_vm.adj_or_not = 'adj'}}},[_c('div',{staticClass:"tag-title"},[_vm._v("ClinSRs after collective adjustment")])]),_c('div',{class:[
      'calMethod',
      _vm.adj_or_not == 'not'
        ? `calMethod-active-${_vm.calMethod}`
        : 'calMethod-deactive',
    ],on:{"click":function($event){_vm.adj_or_not = 'not'}}},[_c('div',{staticClass:"tag-title"},[_vm._v("ClinSRs before collective adjustment")])])]),('time_window' in this.graph)?_c('div',{staticStyle:{"height":"700px"}},[_c('BaseECharts',{attrs:{"option":_vm.chartOption}})],1):_vm._e(),_c('NewDataNote')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }